export default [
  {
    title: 'breadcrumb.workingReport',
    icon: 'BarChart2Icon',
    children: [
      {
        title: 'breadcrumb.overview',
        route: 'service-overview',
        icon: '',
        resource: 'manage-service-overview',
        action: 'read',
      },
      {
        title: 'breadcrumb.performance',
        route: 'employee-performance-overview',
        icon: '',
        resource: 'employee-performance',
        action: 'read',
      },
    ],
  },
]
